// App entry for lean Vite config
// Import any global polyfills or initializations here if needed
// Then import your existing modules in order or discover them dynamically.

// IMPORTANT: Load scripts.js FIRST to define global functions like trapFocus, isEmptyOrSpaces, etc.
// that other modules depend on
import './scripts/scripts.js';

// Then load all modules (sorted by path for stable order)
// Using eager: true means they're evaluated immediately at import time, just like Gulp concatenation
const modules = import.meta.glob('./modules/*.js', { eager: true });

// Modules are already loaded due to eager: true, but we iterate to maintain compatibility
Object.keys(modules)
    .sort()
    .forEach((key) => {
        // modules[key] is already evaluated - nothing to do here
        // This loop is just for documentation/clarity
    });
